import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gt-ip-settings',
  templateUrl: './gt-ip-settings.component.html',
  styleUrls: ['./gt-ip-settings.component.scss']
})
export class GtIpSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
